export const mapAccessType = (municipality, accessType) => {
  switch (accessType) {
    case 'org':
      return municipality.setting?.org_name || 'Org'
    case 'object':
      return municipality.setting?.object_name || 'Object'
    case 'seg_one':
    case 'fund':
      return municipality.setting?.seg_one_name || 'Seg One'
    case 'seg_two':
      return municipality.setting?.seg_two_name || 'Seg Two'
    case 'seg_three':
      return municipality.setting?.seg_three_name || 'Seg Three'
    case 'seg_four':
      return municipality.setting?.seg_four_name || 'Seg Four'
    case 'seg_five':
      return municipality.setting?.seg_five_name || 'Seg Five'
    case 'seg_six':
      return municipality.setting?.seg_six_name || 'Seg Six'
    case 'seg_seven':
      return municipality.setting?.seg_seven_name || 'Seg Seven'
    case 'seg_eight':
      return municipality.setting?.seg_eight_name || 'Seg Eight'
    case 'project':
      return municipality.setting?.project_name || 'Project'
    default:
      return accessType
  }
}
